"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoDeliveryFormatToJSON = exports.VideoDeliveryFormatFromJSONTyped = exports.VideoDeliveryFormatFromJSON = exports.VideoDeliveryFormat = void 0;
/**
 *
 * @export
 */
exports.VideoDeliveryFormat = {
    InStream: 'IN_STREAM',
    OptIn: 'OPT_IN'
};
function VideoDeliveryFormatFromJSON(json) {
    return VideoDeliveryFormatFromJSONTyped(json, false);
}
exports.VideoDeliveryFormatFromJSON = VideoDeliveryFormatFromJSON;
function VideoDeliveryFormatFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.VideoDeliveryFormatFromJSONTyped = VideoDeliveryFormatFromJSONTyped;
function VideoDeliveryFormatToJSON(value) {
    return value;
}
exports.VideoDeliveryFormatToJSON = VideoDeliveryFormatToJSON;
